export enum GlobalDisclaimerLevel {
	app = 'app',
	page = 'page',
}
